import { render, staticRenderFns } from "./VipLevel.vue?vue&type=template&id=5150a7a4&scoped=true"
import script from "./VipLevel.vue?vue&type=script&lang=js"
export * from "./VipLevel.vue?vue&type=script&lang=js"
import style0 from "./VipLevel.vue?vue&type=style&index=0&id=5150a7a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5150a7a4",
  null
  
)

export default component.exports